import Client from './Clients/AxiosClient'
const resource = '/appointments'

export default {
  get(params = {}) {
    return Client.get(resource, { params })
  },
}
